import TypingText from "../markdown/TypingText";
import TypingIndicator from "../markdown/TypingIndicator";
import { twMerge } from "tailwind-merge";
import { Message } from "ai";
import { useMemo, useRef } from "react";
import { DocumentView } from "../../helpers/Models";
import { turnMessageRefsIntoLinks } from "../../helpers/chat-helpers";

interface ChatMessageProps {
  message: Message;
  isStreaming?: boolean;
  opinionSentences?: string[];
  opinionId: string;
  caseName: string | null;
  isLastMessage?: boolean;
  files?: { name: string; type: string }[];
}

export const ChatMessage = ({
  message,
  isLastMessage,
  opinionSentences,
  isStreaming,
  opinionId,
  caseName,
}: ChatMessageProps) => {
  const processedMessageRef = useRef<string>("");

  const processedMessage = useMemo(() => {
    /**
     * Only process the last message to avoid unnecessary processing
     * the previous messages are already processed
     */
    if (isLastMessage) {
      let newMessage = message.content;
      if (document && message.role === "assistant" && opinionSentences && !isStreaming) {
        newMessage = turnMessageRefsIntoLinks(newMessage, opinionSentences, caseName, opinionId);
        console.log("newMessage", newMessage);
      }
      processedMessageRef.current = newMessage;
      return newMessage;
    } else {
      return processedMessageRef.current;
    }
  }, [message, isStreaming, opinionSentences, document, isLastMessage]);

  return (
    <div className="text-[14px]">
      <div>
        {message.role === "user" ? (
          <div>
            <hr className="my-[16px] border-gray-200" />
            <div className={twMerge("text-[#6A6C72] text-[15px] pb-[3px]")}>{processedMessage}</div>
          </div>
        ) : (
          <TypingText text={processedMessage} />
        )}
      </div>
    </div>
  );
};
